export const PLAYBOOK = 255;
export const SEQUENCE = 200;
export const SNIPPET = 150;
export const TEMPLATE = 256;